import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { ImageLightboxComponent } from './Common/ChildComponents/image-lightbox/image-lightbox.component';
import { SessionIdleService } from './Common/session-idle.service';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
  imports: [RouterOutlet, ImageLightboxComponent],
})
export class AppComponent
{
    /**
     * Constructor
     */
  constructor(
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private sessionIdleService: SessionIdleService,
  )
    {
      this.sessionIdleService.start();

      //Register all custom icons

    this.matIconRegistry.addSvgIcon(
      "dashboard", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Dashboard.svg"),
    );

    this.matIconRegistry.addSvgIcon(
      "post_order", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Post_Order.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "gps_tracker", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/GPS_Tracker.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "visitor_manager", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Visitor_Manager.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "reports", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Reports.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "scheduler", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Scheduler.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "parking_manager", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Parking_Manager.svg"),
    );

    this.matIconRegistry.addSvgIcon(
      "dispatcher", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Dispatcher.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "time_clock", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Time_Clock.svg"),
    );
    this.matIconRegistry.addSvgIcon(
      "activity", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/menu/light/Activity.svg"),
    );
      this.matIconRegistry.addSvgIcon(
        "pdf", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/pdf.svg"),
      );

      this.matIconRegistry.addSvgIcon(
        "excel", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/excel.svg"),
      );

      this.matIconRegistry.addSvgIcon(
        "filter", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/filter.svg"),
      );

      this.matIconRegistry.addSvgIcon(
        "import", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/import.svg"),
      );

      this.matIconRegistry.addSvgIcon(
        "more", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/more.svg"),
      );

    this.matIconRegistry.addSvgIcon(
      "custom-column", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/custom/custom_column.svg"),
    );



    }
}
